import React, { useState, useRef } from 'react';
import {
  Menu, MenuButton, MenuList, MenuItem,
  Box, Button, Flex, Text, HStack, IconButton, Badge, Select,
  AlertDialog, AlertDialogBody, AlertDialogFooter, AlertDialogHeader, AlertDialogContent, AlertDialogOverlay,
} from '@chakra-ui/react';
import { ViewIcon, ExternalLinkIcon, EditIcon, DeleteIcon } from '@chakra-ui/icons';

const InvoiceList = ({ invoices, onEdit, onDelete, onViewDetails, onPrintInvoice, onChangeStatus }) => {
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);
  const cancelRef = useRef();

  const handleDeleteClick = (id) => {
    setSelectedInvoiceId(id);
    setIsAlertOpen(true);
  };

  const confirmDelete = () => {
    if (selectedInvoiceId !== null) {
      onDelete(selectedInvoiceId);
      setSelectedInvoiceId(null);
      setIsAlertOpen(false);
    }
  };

  return (
    <>
      {invoices.map((invoice) => (
        <Box key={invoice.id} p="4" borderWidth="1px" borderRadius="md" bg="gray.50" boxShadow="md">
          <Flex justify="space-between" align="center">
            <Box>
              <Text fontWeight="bold">Накладна #{invoice.id}</Text>
              <Text>Дата створення: {new Date(invoice.created_at).toLocaleString()}</Text>

              <Menu>
                <MenuButton>
                  <Badge colorScheme={
                    invoice.status === 'completed'
                      ? 'green'
                      : invoice.status === 'pending'
                        ? 'orange'
                        : 'blue'
                  }>
                    {invoice.status === 'new' ? 'новий' : invoice.status === 'pending' ? 'в очікуванні' : 'проведено'}
                  </Badge>
                </MenuButton>
                <MenuList>
                  <MenuItem onClick={() => onChangeStatus(invoice.id, 'new')}>Новий</MenuItem>
                  <MenuItem onClick={() => onChangeStatus(invoice.id, 'pending')}>В очікуванні</MenuItem>
                  <MenuItem onClick={() => onChangeStatus(invoice.id, 'completed')}>Проведено</MenuItem>
                </MenuList>
              </Menu>
            </Box>
            <HStack>
              <IconButton icon={<ViewIcon />} size="sm" onClick={() => onViewDetails(invoice.id)} aria-label="View" />
              <IconButton icon={<ExternalLinkIcon />} size="sm" onClick={() => onPrintInvoice(invoice.id)} aria-label="Print" />
              <IconButton icon={<EditIcon />} size="sm" onClick={() => onEdit(invoice.id)} aria-label="Edit" isDisabled={invoice.status === 'completed'} />
              <IconButton icon={<DeleteIcon />} size="sm" colorScheme="red" onClick={() => handleDeleteClick(invoice.id)} aria-label="Delete" />
            </HStack>
          </Flex>
        </Box>
      ))}

      <AlertDialog
        isOpen={isAlertOpen}
        leastDestructiveRef={cancelRef}
        onClose={() => setIsAlertOpen(false)}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Підтвердження видалення
            </AlertDialogHeader>

            <AlertDialogBody>
              Ви впевнені, що хочете видалити цю накладну? Цю дію не можна буде скасувати.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={() => setIsAlertOpen(false)}>
                Скасувати
              </Button>
              <Button colorScheme="red" onClick={confirmDelete} ml={3}>
                Видалити
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default InvoiceList;
